import angular from 'angular'

import { isFinite, isString } from 'lodash-es'

angular
  .module('ggs.gallery-sharing')
  .factory('shareToSocial', ShareToSocialProvider)

function ShareToSocialProvider(Socialshare) {
  const PROVIDER_TO_FIELDS = {
    email: {
      url: 'socialshareBody',
      text: 'socialshareSubject',
      media: null,
      width: null,
      height: null
    },
    facebook: {
      url: 'socialshareUrl',
      text: null,
      media: null,
      width: 'socialsharePopupWidth',
      height: 'socialsharePopupHeight'
    },
    twitter: {
      url: 'socialshareUrl',
      text: 'socialshareText',
      media: null,
      width: 'socialsharePopupWidth',
      height: 'socialsharePopupHeight'
    },
    pinterest: {
      url: 'socialshareUrl',
      text: 'socialshareText',
      media: 'socialshareMedia',
      width: 'socialsharePopupWidth',
      height: 'socialsharePopupHeight'
    },
    tumblr: {
      url: 'socialshareUrl',
      text: 'socialshareText',
      media: 'socialshareMedia',
      width: 'socialsharePopupWidth',
      height: 'socialsharePopupHeight'
    }
  }

  const PROVIDER_TO_DIMENSION = {
    email: {
      width: null,
      height: null
    },
    facebook: {
      width: 660,
      height: 660
    },
    twitter: {
      width: 660,
      height: 253
    },
    pinterest: {
      width: 750,
      height: 772
    },
    tumblr: {
      width: 555,
      height: 600
    }
  }

  return function shareToSocial(provider, url, text, media) {
    const fields = PROVIDER_TO_FIELDS[provider]
    const dimension = PROVIDER_TO_DIMENSION[provider]

    const attrs = {}
    if (isString(fields.url)) attrs[fields.url] = url
    if (isString(fields.text)) attrs[fields.text] = text
    if (isString(fields.media)) attrs[fields.media] = media

    if (isString(fields.width) && isFinite(dimension.width)) attrs[fields.width] = dimension.width
    if (isString(fields.height) && isFinite(dimension.height)) attrs[fields.height] = dimension.height

    return Socialshare.share({ provider, attrs })
  }
}
